// Png images
import airplane from './png/airplane.png';
import notFound from './png/notFound.png';
import howItworksBg from './png/home-img-hiw.png';
import clickStartBg from './png/home-img-cls.png';
import answerTheQuestionBg from './png/home-img-atq.png';
import registerAndWaitBg from './png/home-img-raw.png';
import stepsArrow from './png/steps-arrow.png';
import logoExample from './png/logo-example.png';
import logout from './png/logout-icon.png';
import logoHotOffer from './png/logoHotOffer.png';
import airline from './png/airline.png';
import hotBackground from './png/hotBackground.png';
import discoverBack from './png/discoverBack.png';
import more from './png/more.png';
import travelcon from './png/travelcon.png';
import hotSeconc from './png/hotSeconc.png';
import world from './png/world.png';
import familyTravel from './png/familyTravel.png';
import popularPlaces from './png/popularPlaces.png';
import popularMap from './png/popularMap.png';
import popularLine from './png/popularLine.png';
import ourTeam from './png/ourTeam.png';
import ourTeamBack from './png/ourTeamBack.png';
import withUs from './png/withUs.png';
import sun from './png/sun.png';
import teamWord from './png/teamWord.png';
import lineAir from './png/lineAir.png';
import hotBack from './png/hotBack.png';
import buttonLine from './png/buttonLine.png';
import contactUsLayer from './png/contactUsLayaer.png';
import phone from './png/phone.png';
import message from './png/message.png';
import placemaker from './png/placemaker.png';
import settingsImage from './png/settingsImage.png';
import loader from './png/loader.png';
import globalization from './png/globalization.png';
import defaultAvatar from './png/defaultAvatar.png';
import closeBlueIcon from './png/Vector.png';
import step1 from './png/step1.png';
import step2 from './png/step2.png';
import step3 from './png/step3.png';
import destinationAmice from './png/destinationAmice.png';
import italyFlag from './png/italyFlag.png';
import GoogleIcon from './png/GoogleIcon.png';
import AddRequestPlusIcon from './png/addRequestPlusIcon.png';
import UserImage from './png/userImg.png';
import globus from './png/globus.png';
import hamburgerIcon from './png/hamburger-icon.png';
// Jpg images

import contactWorld from './jpg/contactWorld.jpg';
import loginBackground from './jpg/login-background.jpg';
import settingImg from './jpg/settingImg.jpg';
import italy from './jpg/italy.jpg';
import waitingBack from './jpg/waitingBack.jpg';
import rome from './jpg/rome.jpg';
import bali from './jpg/bali.jpg';
import plane from './jpg/plane.jpg';
import teamMember from './jpg/teamMember.jpg';
import work from './jpg/work.jpg';
import peoples from './jpg/peoples.jpg';
import popularImage from './jpg/popularImage.jpg';
import discoverBackSecond from './jpg/discoverBackSecond.jpg';
import questionsBg from './jpg/questions-bg.jpg';
import discoweImg from './jpg/discoweImg.jpg';
import bgHomeSlider from './jpg/bg-slider-home.jpg';
import homeSection1 from './jpg/homeSection1.jpg';
import homeSection2 from './jpg/homeSection2.jpg';
import homeSection3 from './jpg/homeSection3.jpg';
import messageImage from './jpg/messageImage.jpg';
import messagesBackground from './jpg/messagesBackground_1.jpg';
import contactUsBackground from './jpg/ContactUsBackground.jpg';
import mainBgImage from './jpg/welcome-main-sec-bg.jpg';
import footerBgImage from './jpg/welcome-footer-bg.jpg';
import popularPlaceBail from './jpg/popular-place-bail.jpg';
import popularPlaceVenice from './jpg/popular-place-venice.jpg';
import popularPlaceLondon from './jpg/popular-place-london.jpg';
import welcomeClientsFeedbackBg from './jpg/welcome-clients-feedback-bg.jpg';
import settingsBackground from './jpg/SettingsBackground.jpg';
import settingsBackgroundOrigin from './jpg/bgSetings.jpg';
import veniceItaly from './jpg/veniceItaly.jpg';
import slide1 from './jpg/slider-1.jpg';
import slide2 from './jpg/slider-2.jpg';
import slide3 from './jpg/slider-3.jpg';
import slide4 from './jpg/slider-4.jpg';
import slide5 from './jpg/slider-5.jpg';
import slide6 from './jpg/slide6.jpg';
import CountDownBackground2 from './jpg/CountDownImage2.jpg';
import CountDownBackground3 from './jpg/CountDownImage3.jpg';
import CountDownBackground4 from './jpg/CountDownImage4.jpg';
import loginMainBackground from './jpg/LoginBackground.jpg';
import RequestsBackground from './jpg/requestsBg.jpg';

// Svg images
import toursIcon from './svg/toursIcon.svg';
import logOut from './svg/logOut.svg';
import langGuage from './svg/langGuage.svg';
import contactUs from './svg/contactUs.svg';
import aboutUs from './svg/aboutUs.svg';
import home from './svg/home.svg';
import request from './svg/request.svg';
import messages from './svg/messages.svg';
import settings from './svg/settings.svg';
import facebookIcon from './svg/facebook.svg';
import destinationCuate from './svg/destinationCuate.svg';
import FacebookWhiteIcon from './svg/facebookWhiteVector.svg';
import GoogleNoBackGrIcon from './svg/googleNoBackGrIcon.svg';
import instaGray from './svg/insta.svg';
import twitterGraySvg from './svg/twit.svg';
import telegaGray from './svg/teleg.svg';
import faceGray from './svg/face.svg';
import PlanningSteps from './svg/PlanningSteps.svg';
import selectIcon from './svg/select-icon.svg';
import loaderGlobous from './svg/loaderGlobous.svg';
import loaderIcon from './svg/loaderIcon.svg';
import emoji from './svg/emoji.svg';
import sendMessage from './svg/sendMessage.svg';
import heart from './svg/heart.svg';
import fillHeart from './svg/fillHearth.svg';
import fillChat from './svg/fillChat.svg';
import chat from './svg/chat.svg';
import whiteArrowRight from './svg/white-arrow-right.svg';
import downArrow from './svg/downArrow.svg';
import whiteArrowLeft from './svg/white-arrow-left.svg';
import instagramIcon from './svg/instagram.svg';
import twitterIcon from './svg/twitter.svg';
import linkedinIcon from './svg/linkedin.svg';
import homeCarouselArrowR from './svg/home-carousel-arrow-R.svg';
import homeCarouselArrowL from './svg/home-carousel-arrow-L.svg';
import passwordClosedEye from './svg/password-closed-eye-icon.svg';
import passwordOpenedEye from './svg/password-opened-eye-icon.svg';
import authFbIcon from './svg/auth-fb.svg';
import authGoogleIcon from './svg/auth-google.svg';
import stepperDone from './svg/stepperDone.svg';
import close from './svg/close.svg';
import settingsTopCloud from './svg/settings-top-cloud.svg';
import settingsBottomCloud from './svg/settings-bottom-cloud.svg';
import stars from './svg/stars.svg';
import starsinfo from './svg/starsinfo.svg';
import success from './svg/success.svg';
import CountDownImage from './svg/CountDownImage.svg';
import planeSpiral from './svg/planeSpiral.svg';

import first from './svg/first.svg';
import second from './svg/second.svg';
import third from './svg/third.svg';
import fourth from './svg/fourth.svg';
import fifth from './svg/fifth.svg';
import backArrow, { ReactComponent as BackArrow } from './svg/back-arrow.svg';
import selectArrow, { ReactComponent as SelectArrow } from './svg/select-arrow.svg';
import { ReactComponent as SettingsBurger } from './svg/settings-burrger.svg';
import whiteCloseIcon, {
  ReactComponent as WhiteCloseIcon,
} from './svg/white-close-icon.svg';
import whiteUserIcon, {
  ReactComponent as WhiteUserIcon,
} from './svg/white-user-icon.svg';
import whiteLockIcon, {
  ReactComponent as WhiteLockIcon,
} from './svg/white-lock-icon.svg';
import { ReactComponent as UploadPhoto } from './svg/upload-photo.svg';
import { ReactComponent as TrashIcon } from './svg/trash-icon.svg';
import block from './svg/block.svg';
import edit from './svg/edit.svg';
import del from './svg/del.svg';
import letter from './svg/letter.svg';
import geolocation from './svg/geolocation.svg';
import phoneDark from './svg/phoneDark.svg';
import facebookIconBlueGreen from './svg/facebookVector.svg';
import instagramIconBlueGreen from './svg/instagramVector.svg';
import twitterIconBlueGreen from './svg/twitterVector.svg';
import linkedinIconBlueGreen from 'assets/images/svg/linkedinVector.svg';
import logo from './svg/logo.svg';
import editMarker from './svg/EditMarker.svg';
import userIcon from './svg/userIcon.svg';
import languageIcon from './svg/languageIcon.svg';
import burgerIcon from './svg/burgerIcon.svg';
import burgerCloseIcon from './svg/burgerCloseIcon.svg';
import aboutUsIcon from './svg/aboutUsIcon.svg';
import contactUsIcon from './svg/contactUsIcon.svg';
import popularDestinations from './svg/popularDestinations.svg';
import homeIcon from './svg/homeIcon.svg';
import howItWorkIcon from './svg/howItWorkIcon.svg';
import requestIcon from './svg/requestIcon.svg';
import settingsIcon from './svg/settingsIcon.svg';
import favoriteIcon from './svg/favoriteIcon.svg';
import rowDown from './svg/rowDown.svg';
import rowUp from './svg/rowUp.svg';
import backVector from './svg/BackVector.svg';
import downVector from './svg/downVector.svg';
import redRecycleBin from './svg/redresyclebin.svg';
import addPhoto from './svg/addPhoto.svg';
import backVectorIcon from './svg/backVectorIcon.svg';
import readMoreIcon from './svg/readMore.svg';
import plusIcon from './svg/plusIcon.svg';
import minusIcon from './svg/minusIcon.svg';
import mainColorRightArrow from './svg/mainColorRightArrow.svg';
import calendarIcon from './svg/calendar.svg';
import whiteLogo from './svg/whiteLogo.svg';
import userGroup from './svg/userGroup.svg';
import hotOfferGroup from './svg/hotOfferGroup.svg';
import packageGroup from './svg/packageGroup.svg';
import requestGroup from './svg/requestGroup.svg';
import questionGroup from './svg/questionGroup.svg';
import suggestionGroup from './svg/suggestionGroup.svg';
import adminDefaultImage from './svg/adminDefaultImage.svg';
import searchIcon from './svg/searchIcon.svg';
import reverseIcon from './svg/reverseIcon.svg';
import editButton from './svg/editButton.svg';
import deleteButton from './svg/deleteIcon.svg';
import eyeIcon from './svg/eyeIcon.svg';
import userDefaultImage from './svg/userDefaultImage.svg';
import rightVector from './svg/rightVector.svg';
import resetVector from './svg/resetVector.svg';
import userVector from './svg/userVector.svg';
import doneIcon from './svg/doneIcon.svg';
import closeSilverIcon from './svg/closeSilverIcon.svg';
import eyeSilverIcon from './svg/eyeSilverIcon.svg';
import noteButton from './svg/noteButton.svg';
import adminCloseIcon from './svg/adminCloseIcon.svg';
import selectDownArrow from './svg/selectDownArrow.svg';
import silverStarsIcon from './svg/silverStarsIcon.svg';
import plusSilverIcon from './svg/plusSilverIcon.svg';
import whitePlusIcon from './svg/whitePlusIcon.svg';
import eyeClosedSilverEye from './svg/eyeClosedSilverIcon.svg';
import doneIconMainColor from './svg/doneIconMainColor.svg';
import selectDownArrowSilverIcon from './svg/selectDownArrowSilver.svg';
import monitorSilverIcon from './svg/monitorSilverIcon.svg';

// Import like React Component
import { ReactComponent as ScrollToTopArrow } from './svg/arrow-up-for-scroll-to-top.svg';

export const Images = {
  // Png images
  homeIcon,
  howItWorkIcon,
  requestIcon,
  settingsIcon,
  favoriteIcon,
  rowDown,
  rowUp,
  logo,
  burgerIcon,
  aboutUsIcon,
  contactUsIcon,
  popularDestinations,
  burgerCloseIcon,
  GoogleIcon,
  userIcon,
  languageIcon,
  homeSection1,
  homeSection2,
  homeSection3,
  globalization,
  italy,
  defaultAvatar,
  settingsImage,
  step1,
  step2,
  step3,
  destinationCuate,
  messagesBackground,
  destinationAmice,
  italyFlag,
  messageImage,
  airplane,
  howItworksBg,
  clickStartBg,
  answerTheQuestionBg,
  registerAndWaitBg,
  stepsArrow,
  logoExample,
  slide1,
  slide2,
  slide3,
  slide4,
  slide5,
  questionsBg,
  loginBackground,
  logoHotOffer,
  airline,
  hotBackground,
  discoverBack,
  more,
  travelcon,
  discoverBackSecond,
  hotSeconc,
  world,
  waitingBack,
  familyTravel,
  popularPlaces,
  popularMap,
  popularLine,
  popularImage,
  rome,
  bali,
  plane,
  ourTeam,
  ourTeamBack,
  teamMember,
  withUs,
  work,
  peoples,
  sun,
  teamWord,
  lineAir,
  settingImg,
  hotBack,
  buttonLine,
  contactWorld,
  contactUsLayer,
  phone,
  message,
  placemaker,
  instaGray,
  UserImage,
  telegaGray,
  faceGray,
  notFound,
  loader,
  loaderIcon,
  bgHomeSlider,
  // Jpg Images
  mainBgImage,
  footerBgImage,
  popularPlaceBail,
  popularPlaceVenice,
  popularPlaceLondon,
  welcomeClientsFeedbackBg,
  settingsBackground,
  settingsBackgroundOrigin,
  // Svg images
  twitterGraySvg,
  toursIcon,
  logOut,
  langGuage,
  contactUs,
  aboutUs,
  home,
  request,
  messages,
  settings,
  facebookIcon,
  loaderGlobous,
  whiteArrowRight,
  settingsTopCloud,
  whiteArrowLeft,
  instagramIcon,
  twitterIcon,
  linkedinIcon,
  homeCarouselArrowR,
  homeCarouselArrowL,
  passwordClosedEye,
  passwordOpenedEye,
  authFbIcon,
  authGoogleIcon,
  stepperDone,
  close,
  logout,
  selectArrow,
  backArrow,
  settingsBottomCloud,
  whiteCloseIcon,
  whiteUserIcon,
  whiteLockIcon,
  downArrow,
  stars,
  starsinfo,
  success,
  discoweImg,
  heart,
  fillHeart,
  backVectorIcon,
  fillChat,
  chat,
  sendMessage,
  emoji,
  first,
  second,
  third,
  fourth,
  fifth,
  block,
  edit,
  del,
  selectIcon,
  loginMainBackground,
  RequestsBackground,
  AddRequestPlusIcon,
  CountDownImage,
  CountDownBackground2,
  CountDownBackground3,
  CountDownBackground4,
  contactUsBackground,
  letter,
  geolocation,
  phoneDark,
  facebookIconBlueGreen,
  instagramIconBlueGreen,
  twitterIconBlueGreen,
  linkedinIconBlueGreen,
  closeBlueIcon,
  FacebookWhiteIcon,
  GoogleNoBackGrIcon,
  editMarker,
  backVector,
  downVector,
  redRecycleBin,
  addPhoto,
  PlanningSteps,
  readMoreIcon,
  slide6,
  plusIcon,
  minusIcon,
  globus,
  veniceItaly,
  mainColorRightArrow,
  calendarIcon,
  planeSpiral,
  whiteLogo,
  hamburgerIcon,
  userGroup,
  hotOfferGroup,
  packageGroup,
  requestGroup,
  questionGroup,
  suggestionGroup,
  adminDefaultImage,
  searchIcon,
  reverseIcon,
  editButton,
  deleteButton,
  eyeIcon,
  userDefaultImage,
  rightVector,
  resetVector,
  userVector,
  doneIcon,
  closeSilverIcon,
  eyeSilverIcon,
  noteButton,
  adminCloseIcon,
  selectDownArrow,
  silverStarsIcon,
  eyeClosedSilverEye,
  plusSilverIcon,
  whitePlusIcon,
  doneIconMainColor,
  selectDownArrowSilverIcon,
  monitorSilverIcon,
};

export const ImagesAsComponent = {
  ScrollToTopArrow,
  WhiteCloseIcon,
  WhiteUserIcon,
  WhiteLockIcon,
  SelectArrow,
  BackArrow,
  SettingsBurger,
  UploadPhoto,
  TrashIcon,
  backVectorIcon,
};
